import React, {useEffect} from 'react';
import { get } from 'lodash';
import {  useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import RouteComponent from "../routes/RouteComponent";
import isAuthenticated from "../utils/auth";
import History from '../store/history';
import { getCookie } from '../utils/AEMUtils';
import { Helmet } from "react-helmet";

const App = ()=> {
  const customerPageContentData = useSelector(state=> state.CommonReducer.pageContent);
  const { DashboardAEMContent } = useSelector(state => state.DashboardAEMReducer);
  const context = JSON.parse(getCookie('AEM_POST_FLAG'));
  useEffect(() => {
    isAuthenticated();
  }, []);

  // Universal hide-on-scroll-down / show-on-scroll-up for both React and AEM headers
  // Only active on mobile/tablet (< 1024px)
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      // Only apply on mobile screens
      if (window.innerWidth >= 1024) {
        const header = document.querySelector('.main-nav');
        if (header) header.classList.remove('nav-hidden');
        document.body.classList.remove('header-hidden');
        return;
      }
      const currentScrollY = window.scrollY;
      if (Math.abs(currentScrollY - lastScrollY) < 10) return;
      const shouldHide = currentScrollY > lastScrollY && currentScrollY > 80;
      const header = document.querySelector('.main-nav');
      if (header) {
        if (shouldHide) {
          header.classList.add('nav-hidden');
          document.body.classList.add('header-hidden');
        } else {
          header.classList.remove('nav-hidden');
          document.body.classList.remove('header-hidden');
        }
      }
      lastScrollY = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.classList.remove('header-hidden');
    };
  }, []);
  
  return (
    <>
   
      
        {customerPageContentData!==undefined &&
      <Helmet>
        
        
        <title>{get(customerPageContentData, 'Title') !== "" ? get(customerPageContentData, 'Title') :"RCI - the largest timeshare vacation exchange network in the world"}</title>
        <meta name="description" content={get(customerPageContentData, 'Description')}/>
        <meta name="keywords" content={get(customerPageContentData, 'Keywords')}/>
        
        
      </Helmet>
}
      <Router basename={'/pan-weeks-dashboard'} history={History}>
           <RouteComponent history={History} />
      </Router>

    </>
  ) 
 
}

export default App;